import React, { type ReactElement } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import { MIN_TAP_TARGET } from "@/styles/responsive";

interface CLabeledCheckboxProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
}

/**
 * ラベル付きチェックボックスの RHF 対応版。
 * register を MUI の Checkbox に直接渡すと、ステップを戻って再描画したときに
 * 値は true のままチェックの表示だけ外れるため、Controller で checked を制御する。
 */
export const CLabeledCheckbox = <T extends FieldValues>({
  control,
  name,
  label,
}: CLabeledCheckboxProps<T>): ReactElement => (
  <Controller
    control={control}
    name={name}
    render={({ field }) => (
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(field.value)}
            onChange={(event) => {
              field.onChange(event.target.checked);
            }}
            onBlur={field.onBlur}
            inputRef={field.ref}
            // SP で押しやすいよう 44px 四方を確保する（共通の CCheckbox は余白を詰めているため使わない）
            sx={{ minWidth: MIN_TAP_TARGET, minHeight: MIN_TAP_TARGET }}
          />
        }
        label={label}
      />
    )}
  />
);
